// Cross-platform links shown across the marketing/app surfaces.
// The web app freely promotes the iOS app (App Store) — Apple's 3.1.1 only restricts the *iOS app*
// from linking to non-IAP purchasing, not the web direction.

/** App Store product page for the iOS app (ASC App ID 6778836308). */
export const APP_STORE_URL = "https://apps.apple.com/app/id6778836308";
